// extracted by mini-css-extract-plugin
export default {"action":"Q9j_KQDWgshwiWRaVnP9","header":"R5YStyGWTf2u7O2KtkTW","content":"fKjW7xn3MSbnCOTe4W6w"};